export default "__VITE_ASSET__DHb3pvi0__"